/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Toggle_InInputs */

const vi_movement_breakdown_toggle_in = /** @type {(inputs: Movement_Breakdown_Toggle_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập`)
};

/**

* @param {Movement_Breakdown_Toggle_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_toggle_in = /** @type {((inputs?: Movement_Breakdown_Toggle_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Toggle_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_toggle_in(inputs)
});